import Vue from 'vue'
import App from './App.vue'
import router from './routers'
import 'normalize.css'
import '@/lib/iconfont.js'
import { Carousel, CarouselItem, Dropdown, Button, DropdownItem, DropdownMenu } from 'element-ui'

Vue.prototype.$eda = window.eda
Vue.component(Carousel.name, Carousel)
Vue.component(CarouselItem.name, CarouselItem)
Vue.component(Button.name, Button)
Vue.component(Dropdown.name, Dropdown)
Vue.component(DropdownMenu.name, DropdownMenu)
Vue.component(DropdownItem.name, DropdownItem)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
